/*
 * Sunvolt – väljar-guide ("Hjälp mig välja"). Wizard som ställer frågor, poängsätter
 * produkterna och presenterar 1 huvudrekommendation + alternativ med motivering, pris
 * efter grönt teknik-avdrag och en CTA som öppnar konfiguratorn med förifylld
 * konfiguration (?sv_install & ?sv_addons=handle[:variantId] – läses av
 * sunvolt-configurator.js).
 *
 * Produkterna kommer normalt AUTOMATISKT från sektionens kollektion – egenskaperna
 * auto-läses i Liquid (snippets/sunvolt-guide-product) ur specs-metafältet, titeln och
 * varianterna; lastbalanserare + laddkabel följer med ur Tillval-metaobjekten. Blocks
 * i sektionen fungerar som overrides (pitch/manuella egenskaper) och mergas per handle.
 *
 * Bil-frågan använder en inbyggd databas över Sveriges vanligaste laddbara bilar:
 * ombordladdarens max-kW, fastyp och ungefärlig förbrukning (kWh/mil) → resultatet
 * visar bilens faktiska laddhastighet i mil per timme (flaskhalsen är oftast bilen).
 */
(function () {
  /* [namn, ombordladdare kW (standardutförande), faser (1|2|3), förbrukning kWh/mil, phev?] */
  var CAR_DB = [
    ["Tesla Model 3", 11, 3, 1.5],
    ["Tesla Model Y", 11, 3, 1.6],
    ["Tesla Model S (2021–)", 11, 3, 1.8],
    ["Tesla Model X (2021–)", 11, 3, 2.1],
    ["Tesla Model S (2013–2016)", 11, 3, 2.0],
    ["Tesla Model S (2016–2020)", 16.5, 3, 2.0],
    ["Tesla Model X (2016–2020)", 16.5, 3, 2.2],
    ["Volvo EX30", 11, 3, 1.7],
    ["Volvo EX40", 11, 3, 1.9],
    ["Volvo EC40", 11, 3, 1.9],
    ["Volvo XC40 Recharge", 11, 3, 2.0],
    ["Volvo C40 Recharge", 11, 3, 1.9],
    ["Volvo EX90", 11, 3, 2.2],
    ["Volvo ES90", 11, 3, 1.9],
    ["Volvo XC60 T6/T8 Recharge (laddhybrid)", 3.7, 1, 0, true],
    ["Volvo XC90 T8 Recharge (laddhybrid)", 3.7, 1, 0, true],
    ["Volvo XC40 T4/T5 Recharge (laddhybrid)", 3.7, 1, 0, true],
    ["Volvo S60/V60 T6/T8 Recharge (laddhybrid)", 3.7, 1, 0, true],
    ["Volvo S90/V90 T8 Recharge (laddhybrid)", 3.7, 1, 0, true],
    ["Polestar 2", 11, 3, 1.7],
    ["Polestar 3", 11, 3, 2.1],
    ["Polestar 4", 11, 3, 1.8],
    ["Polestar 1 (laddhybrid)", 3.7, 1, 0, true],
    ["Volkswagen ID.3", 11, 3, 1.6],
    ["Volkswagen ID.4", 11, 3, 1.9],
    ["Volkswagen ID.5", 11, 3, 1.8],
    ["Volkswagen ID.7", 11, 3, 1.6],
    ["Volkswagen ID.7 Tourer", 11, 3, 1.7],
    ["Volkswagen ID. Buzz", 11, 3, 2.2],
    ["Volkswagen e-Golf", 7.2, 2, 1.6],
    ["Volkswagen e-up!", 7.2, 2, 1.4],
    ["Volkswagen Golf GTE (2020–2023, laddhybrid)", 3.6, 1, 0, true],
    ["Volkswagen Golf eHybrid/GTE (2024–, laddhybrid)", 11, 3, 0, true],
    ["Volkswagen Passat GTE (–2023, laddhybrid)", 3.6, 1, 0, true],
    ["Volkswagen Passat eHybrid (2024–, laddhybrid)", 11, 3, 0, true],
    ["Volkswagen Tiguan eHybrid (–2023, laddhybrid)", 3.6, 1, 0, true],
    ["Volkswagen Tiguan eHybrid (2024–, laddhybrid)", 11, 3, 0, true],
    ["Volkswagen Arteon eHybrid (laddhybrid)", 3.6, 1, 0, true],
    ["Skoda Enyaq", 11, 3, 1.9],
    ["Skoda Enyaq Coupé", 11, 3, 1.8],
    ["Skoda Elroq", 11, 3, 1.7],
    ["Skoda Citigo-e iV", 7.2, 2, 1.4],
    ["Skoda Superb iV (–2023, laddhybrid)", 3.6, 1, 0, true],
    ["Skoda Superb iV (2024–, laddhybrid)", 11, 3, 0, true],
    ["Skoda Octavia iV (laddhybrid)", 3.6, 1, 0, true],
    ["Skoda Kodiaq iV (2024–, laddhybrid)", 11, 3, 0, true],
    ["Cupra Born", 11, 3, 1.6],
    ["Cupra Tavascan", 11, 3, 1.9],
    ["Cupra Formentor e-Hybrid (–2023, laddhybrid)", 3.6, 1, 0, true],
    ["Cupra Formentor e-Hybrid (2024–, laddhybrid)", 11, 3, 0, true],
    ["Cupra Leon e-Hybrid (laddhybrid)", 3.6, 1, 0, true],
    ["Seat Mii Electric", 7.2, 2, 1.4],
    ["Seat Leon e-Hybrid (laddhybrid)", 3.6, 1, 0, true],
    ["Seat Tarraco e-Hybrid (laddhybrid)", 3.6, 1, 0, true],
    ["Audi Q4 e-tron", 11, 3, 1.9],
    ["Audi Q4 Sportback e-tron", 11, 3, 1.8],
    ["Audi e-tron 50/55", 11, 3, 2.4],
    ["Audi Q8 e-tron", 11, 3, 2.3],
    ["Audi e-tron GT", 11, 3, 2.0],
    ["Audi Q6 e-tron", 11, 3, 1.9],
    ["Audi A6 e-tron", 11, 3, 1.6],
    ["Audi A3 TFSI e (laddhybrid)", 3.6, 1, 0, true],
    ["Audi Q3 TFSI e (laddhybrid)", 3.6, 1, 0, true],
    ["Audi A6/A7 TFSI e (laddhybrid)", 7.4, 1, 0, true],
    ["Audi Q5 TFSI e (laddhybrid)", 7.4, 1, 0, true],
    ["Audi Q7/Q8 TFSI e (laddhybrid)", 7.4, 1, 0, true],
    ["Porsche Taycan", 11, 3, 2.0],
    ["Porsche Macan Electric", 11, 3, 2.0],
    ["Porsche Cayenne E-Hybrid (laddhybrid)", 7.2, 1, 0, true],
    ["Porsche Panamera E-Hybrid (laddhybrid)", 7.2, 1, 0, true],
    ["BMW i3 (2013–2017)", 7.4, 1, 1.5],
    ["BMW i3/i3s (2018–2022)", 11, 3, 1.5],
    ["BMW i4", 11, 3, 1.7],
    ["BMW i5", 11, 3, 1.8],
    ["BMW i7", 11, 3, 2.0],
    ["BMW iX", 11, 3, 2.1],
    ["BMW iX1", 11, 3, 1.8],
    ["BMW iX2", 11, 3, 1.8],
    ["BMW iX3 (2021–2024)", 11, 3, 2.0],
    ["BMW iX3 (2026)", 11, 3, 1.7],
    ["BMW 330e (laddhybrid)", 3.7, 1, 0, true],
    ["BMW 530e (laddhybrid)", 3.7, 1, 0, true],
    ["BMW X1 xDrive25e/30e (laddhybrid)", 3.7, 1, 0, true],
    ["BMW X3 xDrive30e (laddhybrid)", 3.7, 1, 0, true],
    ["BMW X5 xDrive45e (laddhybrid)", 3.7, 1, 0, true],
    ["BMW X5 xDrive50e (laddhybrid)", 7.4, 1, 0, true],
    ["BMW 225xe/230e Active Tourer (laddhybrid)", 3.7, 1, 0, true],
    ["Mini Cooper SE (2020–2023)", 11, 3, 1.5],
    ["Mini Cooper E/SE (2024–)", 11, 3, 1.5],
    ["Mini Aceman", 11, 3, 1.6],
    ["Mini Countryman E/SE", 11, 3, 1.8],
    ["Mini Countryman PHEV (laddhybrid)", 3.7, 1, 0, true],
    ["Mercedes EQA", 11, 3, 1.8],
    ["Mercedes EQB", 11, 3, 1.9],
    ["Mercedes EQC", 11, 3, 2.2],
    ["Mercedes EQE", 11, 3, 1.8],
    ["Mercedes EQE SUV", 11, 3, 2.0],
    ["Mercedes EQS", 11, 3, 1.9],
    ["Mercedes EQS SUV", 11, 3, 2.2],
    ["Mercedes EQV", 11, 3, 2.8],
    ["Mercedes CLA EV (2025–)", 11, 3, 1.4],
    ["Mercedes A250e (laddhybrid)", 3.7, 1, 0, true],
    ["Mercedes C300e (laddhybrid)", 11, 3, 0, true],
    ["Mercedes GLC300e (laddhybrid)", 11, 3, 0, true],
    ["Mercedes E300e/E300de (–2023, laddhybrid)", 7.4, 1, 0, true],
    ["Mercedes E300e (2024–, laddhybrid)", 11, 3, 0, true],
    ["Mercedes GLE350de/400e (laddhybrid)", 7.4, 1, 0, true],
    ["Smart EQ fortwo/forfour", 4.6, 1, 1.6],
    ["Smart #1", 22, 3, 1.9],
    ["Smart #3", 22, 3, 1.8],
    ["Smart #5", 22, 3, 2.1],
    ["Kia e-Niro (2019–2021)", 7.2, 1, 1.6],
    ["Kia Niro EV (2022–)", 11, 3, 1.7],
    ["Kia e-Soul", 7.2, 1, 1.6],
    ["Kia EV3", 11, 3, 1.6],
    ["Kia EV6", 11, 3, 1.9],
    ["Kia EV9", 11, 3, 2.3],
    ["Kia EV4", 11, 3, 1.6],
    ["Kia Niro Plug-in Hybrid (laddhybrid)", 3.3, 1, 0, true],
    ["Kia Ceed/XCeed Plug-in Hybrid (laddhybrid)", 3.3, 1, 0, true],
    ["Kia Sorento Plug-in Hybrid (laddhybrid)", 3.3, 1, 0, true],
    ["Kia Sportage Plug-in Hybrid (laddhybrid)", 7.2, 1, 0, true],
    ["Kia Optima Plug-in Hybrid (laddhybrid)", 3.3, 1, 0, true],
    ["Hyundai IONIQ 5", 11, 3, 1.9],
    ["Hyundai IONIQ 6", 11, 3, 1.5],
    ["Hyundai IONIQ 9", 11, 3, 2.2],
    ["Hyundai Kona Electric (2018–2020)", 7.2, 1, 1.5],
    ["Hyundai Kona Electric (2021–)", 11, 3, 1.6],
    ["Hyundai IONIQ Electric", 7.2, 1, 1.3],
    ["Hyundai INSTER", 11, 3, 1.5],
    ["Hyundai IONIQ Plug-in (laddhybrid)", 3.3, 1, 0, true],
    ["Hyundai Tucson Plug-in Hybrid (laddhybrid)", 7.2, 1, 0, true],
    ["Hyundai Santa Fe Plug-in Hybrid (laddhybrid)", 7.2, 1, 0, true],
    ["Genesis GV60", 11, 3, 2.0],
    ["Genesis Electrified GV70", 11, 3, 2.1],
    ["Genesis Electrified G80", 11, 3, 1.9],
    ["Renault Zoe", 22, 3, 1.7],
    ["Renault Megane E-Tech (2022–2024)", 22, 3, 1.6],
    ["Renault Megane E-Tech (2025–)", 11, 3, 1.6],
    ["Renault Scenic E-Tech", 11, 3, 1.8],
    ["Renault 5 E-Tech", 11, 3, 1.5],
    ["Renault 4 E-Tech", 11, 3, 1.6],
    ["Renault Twingo Electric", 22, 3, 1.3],
    ["Renault Kangoo E-Tech", 11, 3, 2.0],
    ["Renault Captur E-Tech Plug-in (laddhybrid)", 3.7, 1, 0, true],
    ["Renault Megane E-Tech Plug-in (laddhybrid)", 3.7, 1, 0, true],
    ["Dacia Spring", 6.6, 1, 1.3],
    ["Nissan Leaf 24/30 kWh (2014–2017)", 6.6, 1, 1.5],
    ["Nissan Leaf 40/62 kWh (2018–2024)", 6.6, 1, 1.6],
    ["Nissan Ariya 63 kWh", 7.4, 1, 1.9],
    ["Nissan Ariya 87 kWh", 22, 3, 2.0],
    ["Nissan e-NV200", 6.6, 1, 2.0],
    ["Peugeot e-208", 11, 3, 1.6],
    ["Peugeot e-2008", 11, 3, 1.7],
    ["Peugeot e-308", 11, 3, 1.5],
    ["Peugeot e-3008", 11, 3, 1.9],
    ["Peugeot e-5008", 11, 3, 2.0],
    ["Peugeot 308 Hybrid (laddhybrid)", 3.7, 1, 0, true],
    ["Peugeot 3008 Hybrid (laddhybrid)", 3.7, 1, 0, true],
    ["Peugeot 508 Hybrid (laddhybrid)", 3.7, 1, 0, true],
    ["Citroën ë-C4", 11, 3, 1.6],
    ["Citroën ë-C4 X", 11, 3, 1.6],
    ["Citroën ë-C3", 7.4, 1, 1.5],
    ["Citroën ë-Berlingo", 11, 3, 2.0],
    ["Citroën C5 Aircross Hybrid (laddhybrid)", 3.7, 1, 0, true],
    ["Citroën C5 X Hybrid (laddhybrid)", 3.7, 1, 0, true],
    ["Opel Corsa Electric", 11, 3, 1.5],
    ["Opel Mokka Electric", 11, 3, 1.6],
    ["Opel Astra Electric", 11, 3, 1.5],
    ["Opel Grandland Electric", 11, 3, 1.9],
    ["Opel Combo-e", 11, 3, 2.0],
    ["Opel Grandland Plug-in Hybrid (laddhybrid)", 3.7, 1, 0, true],
    ["Opel Astra Plug-in Hybrid (laddhybrid)", 3.7, 1, 0, true],
    ["DS3 E-Tense", 11, 3, 1.6],
    ["DS4 E-Tense (laddhybrid)", 3.7, 1, 0, true],
    ["DS7 E-Tense (laddhybrid)", 3.7, 1, 0, true],
    ["Fiat 500e", 11, 3, 1.4],
    ["Fiat 600e", 11, 3, 1.6],
    ["Fiat Grande Panda Electric", 7.4, 1, 1.5],
    ["Jeep Avenger", 11, 3, 1.7],
    ["Jeep Compass 4xe (laddhybrid)", 7.4, 1, 0, true],
    ["Jeep Renegade 4xe (laddhybrid)", 7.4, 1, 0, true],
    ["Jeep Wrangler 4xe (laddhybrid)", 7.4, 1, 0, true],
    ["Alfa Romeo Junior Elettrica", 11, 3, 1.6],
    ["Alfa Romeo Tonale Plug-in (laddhybrid)", 7.4, 1, 0, true],
    ["Ford Mustang Mach-E", 11, 3, 2.0],
    ["Ford Explorer EV", 11, 3, 1.8],
    ["Ford Capri EV", 11, 3, 1.8],
    ["Ford Puma Gen-E", 11, 3, 1.5],
    ["Ford Kuga Plug-in Hybrid (laddhybrid)", 3.7, 1, 0, true],
    ["Toyota bZ4X (2022, 1-fas)", 6.6, 1, 2.0],
    ["Toyota bZ4X (2023–)", 11, 3, 2.0],
    ["Toyota Prius Plug-in (laddhybrid)", 3.3, 1, 0, true],
    ["Toyota RAV4 Plug-in (laddhybrid)", 6.6, 1, 0, true],
    ["Toyota C-HR Plug-in (laddhybrid)", 6.6, 1, 0, true],
    ["Lexus UX 300e", 6.6, 1, 1.8],
    ["Lexus RZ 450e", 11, 3, 2.0],
    ["Lexus NX 450h+ (laddhybrid)", 6.6, 1, 0, true],
    ["Lexus RX 450h+ (laddhybrid)", 6.6, 1, 0, true],
    ["Mazda MX-30", 6.6, 1, 1.7],
    ["Mazda MX-30 R-EV (laddhybrid)", 7.2, 1, 0, true],
    ["Mazda CX-60 PHEV (laddhybrid)", 7.2, 1, 0, true],
    ["Mazda CX-80 PHEV (laddhybrid)", 7.2, 1, 0, true],
    ["Mazda 6e", 11, 3, 1.7],
    ["Subaru Solterra (2022, 1-fas)", 6.6, 1, 2.1],
    ["Subaru Solterra (2023–)", 11, 3, 2.1],
    ["Honda e", 6.6, 1, 1.7],
    ["Honda e:Ny1", 11, 3, 1.8],
    ["MG4", 11, 3, 1.6],
    ["MG5", 11, 3, 1.7],
    ["MG ZS EV (2020–2021)", 7.4, 1, 1.8],
    ["MG ZS EV (2022–)", 11, 3, 1.8],
    ["MG Marvel R", 11, 3, 2.0],
    ["MG S5 EV", 11, 3, 1.7],
    ["MG Cyberster", 11, 3, 1.9],
    ["MG EHS/HS Plug-in Hybrid (laddhybrid)", 3.7, 1, 0, true],
    ["BYD Atto 3", 11, 3, 1.8],
    ["BYD Dolphin", 11, 3, 1.6],
    ["BYD Dolphin Surf", 11, 3, 1.4],
    ["BYD Seal", 11, 3, 1.7],
    ["BYD Seal U EV", 11, 3, 1.9],
    ["BYD Seal U DM-i (laddhybrid)", 11, 3, 0, true],
    ["BYD Han", 11, 3, 1.9],
    ["BYD Tang", 11, 3, 2.3],
    ["BYD Sealion 7", 11, 3, 1.9],
    ["XPeng P7", 11, 3, 1.8],
    ["XPeng G6", 11, 3, 1.8],
    ["XPeng G9", 11, 3, 2.0],
    ["Nio ET5", 11, 3, 1.9],
    ["Nio ET7", 11, 3, 2.0],
    ["Nio EL6", 11, 3, 2.1],
    ["Nio EL7", 11, 3, 2.2],
    ["Zeekr 001", 22, 3, 1.9],
    ["Zeekr X", 22, 3, 1.8],
    ["Zeekr 7X", 22, 3, 1.9],
    ["Voyah Free", 11, 3, 2.2],
    ["Aiways U5", 11, 3, 1.9],
    ["Aiways U6", 11, 3, 1.9],
    ["Maxus Mifa 9", 11, 3, 2.5],
    ["Ora 03 (Funky Cat)", 11, 3, 1.7],
    ["Leapmotor T03", 6.6, 1, 1.4],
    ["Leapmotor C10", 6.6, 1, 2.0],
    ["Lotus Eletre", 22, 3, 2.3],
    ["Lotus Emeya", 22, 3, 2.1],
    ["Lucid Air", 22, 3, 1.7],
    ["Jaguar I-Pace (2018–2020)", 7.4, 1, 2.3],
    ["Jaguar I-Pace (2021–)", 11, 3, 2.3],
    ["Jaguar F-Pace P400e (laddhybrid)", 7.4, 1, 0, true],
    ["Range Rover P440e/P510e (laddhybrid)", 7.2, 1, 0, true],
    ["Range Rover Sport P440e/P510e (laddhybrid)", 7.2, 1, 0, true],
    ["Range Rover Evoque P300e (laddhybrid)", 7.4, 1, 0, true],
    ["Land Rover Discovery Sport P300e (laddhybrid)", 7.4, 1, 0, true],
    ["Land Rover Defender P400e (laddhybrid)", 7.2, 1, 0, true],
    ["Mitsubishi Outlander PHEV (laddhybrid)", 3.7, 1, 0, true],
    ["Mitsubishi Eclipse Cross PHEV (laddhybrid)", 3.7, 1, 0, true]
  ];

  function fmt(kr) {
    return Math.round(kr).toLocaleString('sv-SE') + ' kr';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ===== Regelmotor: laddbox =====
     Beslutsmatris: bilens ombordladdare = flaskhalsen; 16–20 A huvudsäkring ⇒
     lastbalansering; BRF/företag ⇒ OCPP; sol ⇒ solcellsstyrning; uttag ⇒ kabelval. */
  function scoreLaddbox(p, a) {
    var s = 0, why = [], addons = [];
    var attrs = p.attrs || {};
    var car = a.carData || null;
    var carKw = car ? car.kw : (a.car === 'hybrid' ? 3.7 : 11);
    var isPhev = car ? !!car.phev : a.car === 'hybrid';

    /* Effekt vs bil */
    if (a.car === 'flera') {
      if (attrs.dual) { s += 5; why.push('Två uttag med inbyggd fasbalansering – laddar två bilar samtidigt'); }
      else s -= 2;
    } else {
      if (attrs.dual) s -= 1; /* dubbelbox är overkill för en bil */
      if (attrs.kw >= carKw && attrs.kw >= 11) {
        s += 3;
        if (car) why.push('Klarar din ' + car.name + 's fulla laddeffekt på ' + String(carKw).replace('.', ',') + ' kW');
        else if (isPhev) why.push('Laddar din hybrid fullt – och är redo när nästa bil laddar 11 kW');
        else why.push('11–22 kW 3-fas – rätt nivå för nästan alla nya elbilar');
      } else if (attrs.kw >= carKw) {
        s += 2;
      } else {
        s -= 2; /* boxen stryper bilen */
      }
    }

    /* Laddhastighet i mil/h för kundens bil (Eways-mönstret) */
    if (car && !car.phev && car.cons > 0) {
      var effKw = Math.min(attrs.kw, carKw);
      var milH = Math.round(effKw / car.cons * 10) / 10;
      if (milH >= 1) why.push('≈ ' + String(milH).replace('.', ',') + ' mil räckvidd per laddtimme för din ' + car.name);
    }
    if (car && car.ph < 3 && !car.phev) {
      why.push('Obs: din bil laddar ' + car.ph + '-fas (max ' + String(carKw).replace('.', ',') + ' kW) – boxen är redo för nästa bil');
    }

    /* Boende → OCPP/segment */
    if (a.home === 'brf' || a.home === 'foretag') {
      if (attrs.ocpp) { s += 3; why.push('OCPP – öppen standard för betallösningar, ingen operatörsinlåsning'); }
    } else if (attrs.tier === 'hem') {
      s += 1;
    }

    /* Solceller */
    if ((a.solar === 'ja' || a.solar === 'planerar') && attrs.solar) {
      s += 2; why.push('Solcellsstyrning – laddar på ditt eget överskott');
    }

    /* Kabel vs uttag */
    if (a.cable === 'fast') {
      if (attrs.cable === 'fast' || attrs.cable === 'bada') { s += 2; why.push('Fast laddkabel – alltid redo, inget att släpa fram'); }
      else s -= 1;
    } else if (a.cable === 'uttag') {
      if (attrs.cable === 'uttag' || attrs.cable === 'bada') { s += 2; why.push('Typ 2-uttag – flexibelt, funkar med din egen kabel'); }
      else s -= 1;
    }

    /* Kabellängd → matcha laddkabel-tillvalets variant (auto ur Tillval-metafältet) */
    if (a.cablelen && attrs.cable !== 'fast' && p.kabel && p.kabel.variants) {
      var want = parseInt(a.cablelen, 10);
      var pick = null;
      p.kabel.variants.forEach(function (v) {
        if (!v.available) return;
        var m = parseInt(v.title, 10);
        if (!m) return;
        if (m >= want && (!pick || m < pick.m)) pick = { v: v, m: m };
      });
      if (pick) {
        addons.push({ handle: p.kabel.handle, title: 'Laddkabel ' + pick.v.title, price: pick.v.price, variantId: pick.v.id });
        why.push('Laddkabel ' + pick.v.title + ' ingår i din konfiguration');
      }
    }

    /* Huvudsäkring → lastbalansering */
    var needLb = a.fuse === '16' || a.fuse === '20' || a.fuse === 'vetej';
    if (needLb) {
      if (attrs.lbBuiltin) {
        s += 2; why.push('Dynamisk lastbalansering skyddar din huvudsäkring');
      } else if (p.lb) {
        addons.push(p.lb);
        why.push('Kompletteras med ' + p.lb.title + ' som skyddar din ' + (a.fuse === 'vetej' ? '' : a.fuse + ' A-') + 'huvudsäkring');
      } else {
        /* Vid 16–20 A ska lastbalansering alltid in i bilden – utan lösning på boxen
           flaggas behovet och boxen tappar mot alternativ som har en. */
        s -= 1;
        why.push('Lastbalanserare rekommenderas till din huvudsäkring – väljs i konfiguratorn');
      }
    }

    return { score: s, why: why, addons: addons };
  }

  /* ===== Regelmotor: batteri =====
     Dimensionering enligt branschens tumregel 1–1,5 kWh per kWp solceller, justerad för
     årsförbrukning; mål-viktning (elräkning/stödtjänster/sollagring/backup) styr egenskaper. */
  function scoreBatteri(p, a) {
    var s = 0, why = [], addons = [];
    var attrs = p.attrs || {};

    var targetKwh = 10;
    if (a.solar === 'stor') targetKwh = 16;
    else if (a.solar === 'mellan') targetKwh = 12;
    else if (a.solar === 'liten') targetKwh = 8;
    if (a.usage === 'lag') targetKwh -= 2;
    else if (a.usage === 'hog') targetKwh += 2;
    else if (a.usage === 'mycket') targetKwh += 5;
    if (targetKwh < 5) targetKwh = 5;

    var lo = attrs.kwhMin || 0, hi = attrs.kwhMax || lo;
    if (targetKwh >= lo && targetKwh <= hi) {
      s += 4; why.push('Kapaciteten (' + lo + (hi > lo ? '–' + hi : '') + ' kWh) täcker ditt behov på ~' + targetKwh + ' kWh');
    } else if (hi >= targetKwh && lo <= targetKwh + 4) {
      s += 2;
    } else {
      s -= 2;
    }

    if (attrs.scalable) {
      s += 1;
      if (a.solar === 'planerar') { s += 1; why.push('Modulär – börja lagom och bygg ut när solcellerna är på plats'); }
      else if (hi > lo) why.push('Skalbar ' + lo + '–' + hi + ' kWh – bygg ut i moduler senare');
    }

    if (a.goal === 'stodtjanster') {
      if (attrs.fcr) { s += 3; why.push('Redo för stödtjänster (FCR via aggregator) – ersättningen räknas per kW, och ' + (attrs.kw || '') + ' kW effekt ger bra förutsättningar'); }
      if (attrs.kw >= 10) s += 1;
    }
    if (a.goal === 'backup') {
      if (attrs.backup) { s += 3; why.push('Ö-drift/EPS – huset rullar vidare vid strömavbrott'); }
      else s -= 2;
    }
    if (a.goal === 'sollagring' && attrs.hybrid) { s += 2; }
    if (a.goal === 'elrakning') { s += 1; why.push('Laddar billigt, används när elen är dyr – kapar pristoppar och effektavgifter'); }

    if (a.solar !== 'nej' && attrs.hybrid) { s += 2; why.push('Inbyggd hybridväxelriktare – kopplas direkt mot solcellerna'); }

    if (a.fuse === '16' && attrs.kw >= 10) {
      why.push('Obs: 16 A-huvudsäkring kan begränsa effekten – vi dimensionerar rätt vid offerten');
    }

    if (a.budget && a.budget !== 'alla' && attrs.tier) {
      if (attrs.tier === a.budget) s += 2;
    }

    return { score: s, why: why, addons: addons, targetKwh: targetKwh };
  }

  /* Merge: kollektionens auto-lästa produkter + blocks (per handle). Block-pitch vinner
     alltid; block-attrs bara när "Manuella egenskaper" är ikryssat; lb/kabel behålls
     från auto-läsningen om blocket saknar dem. */
  function mergeProducts(list) {
    var byHandle = {}, order = [];
    list.forEach(function (p) {
      if (!p || !p.handle) return;
      var ex = byHandle[p.handle];
      if (!ex) { byHandle[p.handle] = p; order.push(p.handle); return; }
      if (p.pitch) ex.pitch = p.pitch;
      if (p.manual) ex.attrs = p.attrs;
      if (p.lb) ex.lb = p.lb;
      if (p.kabel) ex.kabel = p.kabel;
    });
    return order.map(function (h) { return byHandle[h]; });
  }

  function init(root) {
    if (root.__svGuide) return;
    root.__svGuide = true;

    var cfgEl = root.querySelector('[data-guide-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var questions = cfg.questions || [];
    var products = mergeProducts(cfg.products || []);
    if (!questions.length || !products.length) return;

    var stage = root.querySelector('[data-guide-stage]');
    var barFill = root.querySelector('[data-guide-bar]');
    var counter = root.querySelector('[data-guide-count]');
    var backBtn = root.querySelector('[data-guide-back]');
    var restartBtn = root.querySelector('[data-guide-restart]');
    if (!stage) return;

    var answers = {};
    var step = 0;
    /* Sätts först när användaren aktivt interagerar – autofokus på bilsöket vid
       FÖRSTA renderingen får annars webbläsaren att scrolla till guiden vid sidladdning. */
    var interacted = false;

    /* Villkorade frågor (showIf): den synliga sekvensen beror på svaren */
    function visible() {
      return questions.filter(function (q) {
        if (!q.showIf) return true;
        return (q.showIf.values || []).indexOf(answers[q.showIf.key]) > -1;
      });
    }

    function progress() {
      var vis = visible();
      var total = vis.length;
      var done = Math.min(step, total);
      if (barFill) barFill.style.width = (done / total * 100) + '%';
      if (counter) counter.textContent = step >= total ? cfg.labels.result : (cfg.labels.question + ' ' + (step + 1) + ' ' + cfg.labels.of + ' ' + total);
      if (backBtn) backBtn.hidden = step === 0;
      if (restartBtn) restartBtn.hidden = step < total;
    }

    function optBtn(o, selected) {
      var html = '<button type="button" class="svg-opt' + (selected ? ' is-selected' : '') + '" role="radio" aria-checked="' + selected + '" data-guide-opt data-value="' + esc(o.value) + '">';
      html += '<span class="svg-opt__t">' + esc(o.label) + '</span>';
      if (o.desc) html += '<span class="svg-opt__d">' + esc(o.desc) + '</span>';
      html += '<span class="svg-opt__check" aria-hidden="true">✓</span></button>';
      return html;
    }

    function renderQuestion() {
      var q = visible()[step];
      var isCar = q.type === 'car';
      var html = '<div class="svg-q" role="radiogroup" aria-label="' + esc(q.title) + '">';
      html += '<h3 class="svg-q__title">' + esc(q.title) + '</h3>';
      if (q.help) html += '<p class="svg-q__help">' + esc(q.help) + '</p>';
      if (isCar) {
        html += '<div class="svg-carsearch">';
        html += '<input type="search" class="svg-carsearch__input" data-car-input placeholder="Sök bilmärke eller modell…" autocomplete="off" aria-label="Sök bilmodell">';
        html += '<div class="svg-carsearch__list" data-car-list role="listbox"></div>';
        html += '</div>';
        if (answers.carData) html += '<p class="svg-carsearch__picked" data-car-picked>Vald bil: <b>' + esc(answers.carData.name) + '</b></p>';
      }
      html += '<div class="svg-q__opts' + (isCar ? ' svg-q__opts--quick' : '') + '">';
      q.options.forEach(function (o) { html += optBtn(o, answers[q.key] === o.value); });
      html += '</div></div>';
      stage.innerHTML = html;

      Array.prototype.forEach.call(stage.querySelectorAll('[data-guide-opt]'), function (btn) {
        btn.addEventListener('click', function () {
          interacted = true;
          answers[q.key] = btn.getAttribute('data-value');
          if (q.type === 'car') answers.carData = null;
          step++;
          render();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      if (isCar) {
        var input = stage.querySelector('[data-car-input]');
        var listEl = stage.querySelector('[data-car-list]');
        var renderList = function (term) {
          var t = (term || '').toLowerCase().trim();
          if (t.length < 1) { listEl.innerHTML = ''; return; }
          var hits = CAR_DB.filter(function (c) { return c[0].toLowerCase().indexOf(t) > -1; }).slice(0, 8);
          listEl.innerHTML = hits.map(function (c, i) {
            return '<button type="button" class="svg-carsearch__item" role="option" data-car-idx="' + CAR_DB.indexOf(c) + '">' + esc(c[0]) + '<span>' + (c[4] ? 'Laddhybrid · ' : '') + String(c[1]).replace('.', ',') + ' kW</span></button>';
          }).join('');
          Array.prototype.forEach.call(listEl.querySelectorAll('[data-car-idx]'), function (b) {
            b.addEventListener('click', function () {
              interacted = true;
              var c = CAR_DB[parseInt(b.getAttribute('data-car-idx'), 10)];
              answers[q.key] = 'db';
              answers.carData = { name: c[0], kw: c[1], ph: c[2], cons: c[3], phev: !!c[4] };
              step++;
              render();
              root.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          });
        };
        input.addEventListener('input', function () { interacted = true; renderList(input.value); });
        /* Autofokus bara mitt i wizarden (t.ex. Tillbaka till bilfrågan) – aldrig vid
           sidladdning, och aldrig så att sidan scrollar. */
        if (interacted) input.focus({ preventScroll: true });
      }
    }

    function buildConfigUrl(p, res) {
      var url = p.configUrl || p.url;
      var params = [];
      if (cfg.type === 'laddbox') params.push('sv_install=standard');
      params.push('sv_goto=summary'); /* landa på summeringen – färdigt paket direkt */
      var handles = res.addons.map(function (ad) {
        if (!ad.handle) return null;
        return ad.variantId ? ad.handle + ':' + ad.variantId : ad.handle;
      }).filter(Boolean);
      if (handles.length) params.push('sv_addons=' + handles.join(','));
      if (!params.length) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + params.join('&');
    }

    function priceAfterGront(p, res) {
      if (!p.price) return null;
      var addonSum = res.addons.reduce(function (sum, ad) { return sum + (ad.price || 0); }, 0);
      var base = p.price + addonSum + (cfg.type === 'laddbox' ? (cfg.installPrice || 0) : 0);
      /* Samma matte som konfiguratorn: avdraget avrundas till hel krona och dras av,
         inte en procentmultiplikation. Annars skiljer sig priserna åt på slutet. */
      var after = base - Math.round(base * (cfg.grontPercent || 0) / 100);
      /* Installations-kampanjrabatt (metafält custom.installationsrabatt, kr) – guidens paket
         inkluderar alltid installation → rabatten dras efter grönt avdrag, som i kassan. */
      if (cfg.type === 'laddbox' && p.installRabatt > 0) {
        after -= p.installRabatt;
        if (after < 0) after = 0;
      }
      return { before: base, after: after };
    }

    function productCard(p, res, isTop) {
      var pr = priceAfterGront(p, res);
      var html = '<article class="svg-card' + (isTop ? ' svg-card--top' : '') + '">';
      if (isTop) html += '<span class="svg-card__badge">' + esc(cfg.labels.topPick) + '</span>';
      html += '<div class="svg-card__media">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" decoding="async">' : '') + '</div>';
      html += '<div class="svg-card__body">';
      html += '<h4 class="svg-card__title">' + esc(p.title) + '</h4>';
      if (p.pitch) html += '<p class="svg-card__pitch">' + esc(p.pitch) + '</p>';
      if (res.why.length) {
        html += '<ul class="svg-card__why">';
        res.why.slice(0, isTop ? 6 : 2).forEach(function (w) { html += '<li>' + esc(w) + '</li>'; });
        html += '</ul>';
      }
      if (pr) {
        if (pr.after < pr.before) {
          html += '<p class="svg-card__price"><b>' + fmt(pr.after) + '</b> <span>' + esc(cfg.labels.afterGront) + '</span></p>';
        } else {
          html += '<p class="svg-card__price"><b>' + fmt(pr.before) + '</b></p>';
        }
      } else {
        html += '<p class="svg-card__price svg-card__price--quote">' + esc(cfg.labels.quotePrice) + '</p>';
      }
      html += '<div class="svg-card__actions">';
      html += '<a class="svg-cta sv-abtn" href="' + esc(buildConfigUrl(p, res)) + '">' + esc(isTop ? cfg.labels.ctaTop : cfg.labels.ctaAlt) + '</a>';
      if (isTop) html += '<a class="svg-cta svg-cta--ghost" href="' + esc(p.url) + '">' + esc(cfg.labels.ctaProduct) + '</a>';
      html += '</div></div></article>';
      return html;
    }

    function renderResult() {
      var ranked = products.map(function (p) {
        var res = cfg.type === 'batteri' ? scoreBatteri(p, answers) : scoreLaddbox(p, answers);
        return { p: p, res: res };
      }).sort(function (a, b) { return b.res.score - a.res.score; });

      var top = ranked[0];
      var alts = ranked.slice(1, 3).filter(function (r) { return r.res.score > -2; });

      var html = '<div class="svg-result" aria-live="polite">';
      html += '<h3 class="svg-result__title">' + esc(cfg.labels.resultTitle) + '</h3>';
      if (cfg.type === 'batteri' && top.res.targetKwh) {
        html += '<p class="svg-result__intro">' + esc(cfg.labels.targetPrefix) + ' <b>~' + top.res.targetKwh + ' kWh</b>. ' + esc(cfg.labels.targetSuffix) + '</p>';
      }
      html += productCard(top.p, top.res, true);
      if (alts.length) {
        html += '<p class="svg-result__alts-label">' + esc(cfg.labels.alternatives) + '</p>';
        html += '<div class="svg-result__alts">';
        alts.forEach(function (r) { html += productCard(r.p, r.res, false); });
        html += '</div>';
      }
      if (cfg.advice && cfg.advice.url) {
        html += '<p class="svg-result__advice">' + esc(cfg.labels.unsure) + ' <a href="' + esc(cfg.advice.url) + '">' + esc(cfg.advice.label) + '</a></p>';
      }
      html += '</div>';
      stage.innerHTML = html;
    }

    function render() {
      progress();
      if (step >= visible().length) renderResult();
      else renderQuestion();
    }

    if (backBtn) backBtn.addEventListener('click', function () { interacted = true; if (step > 0) { step--; render(); } });
    if (restartBtn) restartBtn.addEventListener('click', function () { interacted = true; answers = {}; step = 0; render(); });

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sv-guide]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
